import { Component } from '@angular/core';
import { LoaderService } from '@/app/services/loader/loader.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loader-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader-spinner.component.html',
  styleUrl: './loader-spinner.component.css'
})
export class LoaderSpinnerComponent {
  isLoading = false;

  constructor(private loaderService: LoaderService) {
    this.loaderService.loaderState$.subscribe(state => {
      this.isLoading = state;
    });
  }
}